module.exports = __webpack_public_path__ + "img/shopping-and-ecommerce.6c55e2ed.webp";